import React, { useContext, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import {
  Button,
  Layout,
  MobileTabBar,
  Footer,
  Accordion,
  Input,
  Select,
  SelectFile,
} from '../../components';

import './support.less';
import '../Profile/profile-general.less';
import '../../components/Card/card.less';

import RightChevronIcon from '../../assests/icons/right-chevron.icon';
import { Tabs, Modal, Form } from 'antd';
import { DimensionsContext } from '../../context/dimensions.context';

const { TabPane } = Tabs;

const AccordionList = [
  {
    header: 'İYS (İleti Yönetim Sistemi)’den dolayı hata alıyorum. Ne yapmalıyım?    ',
    content:
      'Ticari SMS gönderi için öncelikle İYS’ye kayıt olmanız gerekmektedir. Gönderim yapmak istediğiniz tüm müşteri telefon numarası listesini İYS’de bulunan izinli veri tabanına yüklemeniz gerekmektedir. İYS izinli veri tabanına numaraları «bireysel» ve «mesaj» izni olarak eklemeniz gerekmektedir. İYS tarafına kayıt olduğunuz vergi numarası ile Mesaj Üssü’ne kayıt olduğunuz vergi numarasının aynı olması gerekmektedir. Sonrasında Mesaj Üssü’ndeki mesaj başlığı bölümünden gönderim yapmak istediğiniz mesaj başlığına İYS marka bilgisini tanımlamanız gerekmektedir.       ',
  },
  {
    header: 'Kullanım bilgileri kaç aya kadar raporlanabiliyor?    ',
    content:
      'Kayıtlar 2 yıla kadar saklanmaktadır.       ',
  }
];
const SubjectList = ['Konu 1', 'Konu 2', 'Konu 3', 'Konu 4', 'Konu 5'];

const SupportReports = () => {
  const [modalSendUs, setModalSendUs] = useState(false);
  const { isTabletBig } = useContext(DimensionsContext);
  const [form] = Form.useForm();

  let history = useHistory();

  function onChangeTabs(key) {
    if (key == 1) {
      history.push('./CreditPurchaseHelp');
    } else if (key == 2) {
      history.push('./MessagesHelp');
    } else if (key == 3) {
      history.push('./ReportsHelp');
    } else if (key == 4) {
      history.push('./AccountsHelp');
    }
  }

  return (
    <Layout>
      <div className="profile-page support">
        <div className="container">
          <div className="profile-page__title">
            <h1 className="section__title">Yardım</h1>
          </div>
          <div className="content-wrapper">
            {isTabletBig ? (
              <div className="profile-page__menu sub-groups">
                <h2 className="box__title">Yardım Konuları</h2>
                <ul>
                  <li>
                    <NavLink
                      to="./CreditPurchaseHelp"
                      classname="active"
                      activeClassName="active"
                    >
                      <span>Kredi Satın Alımı</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="./MessagesHelp"
                      activeClassName="active"
                    >
                      <span>Gönderim İşlemleri</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="./ReportsHelp" activeClassName="active">
                      <span>Raporlar</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="./AccountsHelp" activeClassName="active">
                      <span>Şirket ve Hesaplar</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                </ul>
                <div className="write-us">
                  <span>Sorularınıza yanıt alamadınız mı?</span>
                  <Button
                    type="primary"
                    shape="round"
                    onClick={() => setModalSendUs(true)}
                  >
                    Bize Yazın
                  </Button>
                </div>
              </div>
            ) : (
              <Tabs
                defaultActiveKey="1"
                onChange={onChangeTabs}
                renderTabBar={(props, Item) => {
                  return <MobileTabBar props={props} item={Item} />;
                }}
              >
                <TabPane tab="Kredi Satın Alımı" key="1"></TabPane>
                <TabPane tab="Gönderim İşlemleri" key="2"></TabPane>
                <TabPane tab="Raporlar" key="3"></TabPane>
                <TabPane tab="Şirket ve Hesaplar" key="4"></TabPane>
              </Tabs>
            )}
            <div className="profile-page__content">
              <Accordion list={AccordionList} />
            </div>
            {!isTabletBig ? (
              <div className="write-us">
                <span>Sorularınıza yanıt alamadınız mı?</span>
                <Button
                  type="primary"
                  shape="round"
                  onClick={() => setModalSendUs(true)}
                >
                  Bize Yazın
                </Button>
              </div>
            ) : null}
          </div>
          <Modal
            className="modal--send-us"
            title="Bize Ulaşın "
            visible={modalSendUs}
            onCancel={() => setModalSendUs(false)}
            footer={[
              <div className="modal-action">
                <Button
                  shape="round"
                  type="ghost"
                  onClick={() => setModalSendUs(false)}
                >
                  Vazgeç
                </Button>
                <Button
                  key="confirm"
                  type="primary"
                  onClick={() => {
                    setModalSendUs(false);
                  }}
                >
                  Gönder
                </Button>
              </div>,
            ]}
          >
            <div>
              <Form form={form} name="choose-title">
                <Form.Item
                  rules={[{ required: true }]}
                  name="email"
                  messageVariables={{ label: 'e-mail' }}
                >
                  <Input
                    type="mail"
                    name="add-row-mail"
                    label="E-Posta Adresiniz"
                  />
                </Form.Item>
                <Form.Item
                  rules={[{ required: true }]}
                  name="subject"
                  messageVariables={{ label: 'subject' }}
                >
                  <Select
                    label="Mesajınızın Konusu"
                    data={SubjectList}
                  ></Select>
                </Form.Item>
                <Form.Item rules={[{ required: true }]} name="text-message">
                  <Input.TextArea
                    autoComplete="off"
                    placeholder="Mesajınızı yazın"
                    className="textarea--v2"
                  />
                </Form.Item>
                <Form className="Item">
                  <SelectFile
                    iconless
                    type="file"
                    title={<span>Dosya Yükle</span>}
                  />
                </Form>
              </Form>
            </div>
          </Modal>
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default SupportReports;
